import { reqUserToken } from './req-features/req-user-token';
export const userToken = (options) => [reqUserToken(options)];
